import { ExperimentCountry, ExperimentName } from './types';

export const FEATURE_GATES = {
  homeDeliveryDeactivation: 'home_delivery_deactivation',
  priceReduction: 'price_reduction',
  noSignUpFee: 'no_sign_up_fee',
  sameDayPickup: 'same_day_pickup',
  signUpFeeReduction: 'sign_up_fee_reduction',
  basketAddon: 'basket_addon',
  sepaDirectDebit: 'sepa_direct_debit',
  stripePayment: 'stripe_payment',
} as const;

export const DYNAMIC_CONFIG_NAMES = {
  formerSignUpFee: 'former_sign_up_fee',
  heavyUseRestriction: 'heavy_use_restriction',
  nextDayDeliveryAvailability: 'next_day_delivery_availability',
  storeLocations: 'store_locations',
  threeTierPricingProductsConfig: '3_tier_pricing_products_config',
  unavailableBikeHeightRange: 'unavailable_bike_height_range',
} as const;

export const EXPERIMENTS: {
  [key in ExperimentCountry]?: Partial<Record<ExperimentName, string>>;
} = {
  ALL: {
    newFramerCityPages: 'new_framer_city_pages',
    descriptiveCTAsInSignUp: 'descriptive_ctas_in_sign_up',
    updatedBuckarooPayment: 'updated_buckaroo_payment',
  },
};
